import * as React from 'react'

import * as styles from './SecondToolbar.module.less'

export interface SecondToolbarProps {
    className?: string
    id?: string
    leftAlignedContent?: React.ReactNode
    rightAlignedContent?: React.ReactNode
}

export const SecondToolbar: React.FC<SecondToolbarProps> = (props) => {
    const { id, leftAlignedContent, rightAlignedContent } = props

    if (leftAlignedContent || rightAlignedContent) {
        return (
            <div className={styles.secondToolbar} id={id}>
                <div className={styles.alignLeftContainer}>
                    <div className={styles.alignLeft}>{leftAlignedContent}</div>
                </div>
                <div className={styles.alignRightContainer}>
                    <div className={styles.alignRight}>
                        {rightAlignedContent}
                    </div>
                </div>
            </div>
        )
    } else {
        return <React.Fragment></React.Fragment>
    }
}
